/* Cellulight Gold — PDP behaviour (Shopify port)
   The PDP section emits the product itself into window.CELLULIGHT_PRODUCT:
     { key, name, price, compare, priceText, compareText, off, img, sub, startTier }
   The Bundle & Save ladder is a QUANTITY ladder on that same product: each .tier label
   carries its own figures in data-qty / data-total / data-strike / data-off, rendered
   server-side by Liquid, so nothing about prices is computed here.
*/
(function () {
  'use strict';

  var P = window.CELLULIGHT_PRODUCT;
  if (!P) return;

  var $ = function (id) { return document.getElementById(id); };
  var current = 0;
  /* however many images the product has — read from the DOM rather than a fixed id list, so
     a product with two photos or with eight both get working thumbs and arrows */
  var gal = [].slice.call(document.querySelectorAll('.gal-main img'));
  var thumbs = $('thumbs');
  if (!thumbs) return;
  var thumb0 = thumbs.querySelector('button[data-i="0"] img');
  var q = $('qty');
  var SAVE = P.saveLabel || 'You save';

  var tierEl = function (t) { return document.querySelector('.tier[data-tier="' + t + '"]'); };

  var set = function (id, text) { var e = $(id); if (e) e.textContent = text; };

  /* a tier is N of this product, so only the price block and the quantity move.
     Selection is applied first and unconditionally — a missing price element must
     never be able to leave a click looking like it did nothing. */
  function render(t) {
    var el = tierEl(t);
    if (!el) return;

    document.querySelectorAll('.tier').forEach(function (e2) {
      var on = e2.dataset.tier === String(t);
      e2.classList.toggle('on', on);
      var input = e2.querySelector('input');
      if (input) input.checked = on;
    });

    var d = el.dataset;
    var save = Number(d.off) > 0 ? SAVE + ' ' + d.off + '%' : '';
    set('pPrice', d.total);
    set('pCompare', d.strike || '');
    set('pOff', save);
    /* today's deal restates the selected tier, so it can never advertise a price the
       ladder above it isn't currently offering */
    set('offerPrice', d.total);
    set('offerCompare', d.strike || '');
    set('sPrice', d.total + (save ? ' · ' + save : ''));
    /* the gallery badge quotes this tier's own saving, never a fixed figure */
    set('galBadge', d.save ? 'Save ' + d.save : '');
    tierSaves = Number(d.off) > 0;
    if (q) q.value = d.qty;
    syncOffer();
  }

  /* Only advertise a deal when the selected tier has a saving. Buying multiple
     packages alone does not qualify an undiscounted tier for deal messaging. */
  var tierSaves = false;
  function syncOffer() {
    var show = tierSaves;
    var offerBox = $('offerBox');
    if (offerBox) offerBox.hidden = !show;
    var badge = $('galBadge');
    if (badge) badge.hidden = !show || !badge.textContent;
  }

  function show(i) {
    current = i;
    gal.forEach(function (img, n) {
      if (!img) return;
      /* frames after the first are fetched the first time they are shown: they sit stacked
         in the viewport, so loading=lazy alone pulled every one of them at boot */
      if (n === i && img.dataset.src) {
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        img.src = img.dataset.src;
        delete img.dataset.src; delete img.dataset.srcset;
      }
      img.classList.toggle('on', n === i);
    });
    thumbs.querySelectorAll('button').forEach(function (b) {
      b.classList.toggle('on', Number(b.dataset.i) === i);
    });
  }

  /* delegated: survives a tier being re-rendered, and catches the radio's own change
     event as well as clicks anywhere on the card */
  var tiers = $('tiers');
  if (tiers) ['click', 'change'].forEach(function (ev) {
    tiers.addEventListener(ev, function (e) {
      var el = e.target.closest('.tier');
      if (el) render(Number(el.dataset.tier));
    });
  });
  thumbs.addEventListener('click', function (e) {
    var b = e.target.closest('button');
    if (b) show(Number(b.dataset.i));
  });

  /* prev / next over the main image, wrapping at both ends */
  var galStep = function (d) { show((current + d + gal.length) % gal.length); };
  var gp = $('galPrev'), gn = $('galNext');
  if (gp) gp.addEventListener('click', function () { galStep(-1); });
  if (gn) gn.addEventListener('click', function () { galStep(1); });
  document.addEventListener('keydown', function (e) {
    if (e.target.tagName === 'INPUT') return;
    if (e.key === 'ArrowLeft')  galStep(-1);
    if (e.key === 'ArrowRight') galStep(1);
  });

  if ($('sName')) $('sName').textContent = P.name;
  render(Number(P.startTier) || 1);

  /* the steppers set the value in code, which fires no change event — so they hand the
     box the same event a typed quantity would, and one path keeps everything in step */
  var step = function (d) {
    if (!q) return;
    q.value = Math.min(9, Math.max(1, (parseInt(q.value, 10) || 1) + d));
    q.dispatchEvent(new Event('change'));
  };
  var qm = $('qMinus'), qp = $('qPlus');
  if (qm) qm.addEventListener('click', function () { step(-1); });
  if (qp) qp.addEventListener('click', function () { step(1); });
  /* typing a quantity that matches a tier selects it, so the two never disagree */
  if (q) q.addEventListener('change', function () {
    var match = document.querySelector('.tier[data-qty="' + q.value + '"]');
    if (match) { render(Number(match.dataset.tier)); return; }
    /* a quantity past the top tier still counts as more than one, so the deal stands */
    syncOffer();
  });

  /* the inline script registered this product with the drawer catalogue before the
     deferred cart script booted, so the key resolves */
  /* both the in-page button and the mobile sticky bar carry .atc */
  document.querySelectorAll('.atc').forEach(function (atc) {
    atc.addEventListener('click', function () {
      if (!window.CGCart) return;
      /* quantity only — the drawer applies the same ladder these tiers were rendered
         from, so it arrives at the tier's price on its own. Handing it a price here is
         what let a stale figure outlive a quantity change. */
      window.CGCart.add(P.key, parseInt((q && q.value) || '1', 10) || 1);
      window.CGCart.open();
    });
  });

  var satc = $('satc'), buy = $('buy');
  if (satc && buy) {
    var headerSelector = '#hdr, .clg-header, #header-group, .shopify-section-group-header-group, .announcement-bar, .cellulight-mq-section';
    var root = document.documentElement;
    var originalScrollPadding = root.style.scrollPaddingTop;
    var sync = function () {
      var top = 0;
      document.querySelectorAll(headerSelector).forEach(function (header) {
        var rect = header.getBoundingClientRect();
        // Viewport coordinates account for announcements scrolling away and headers resizing.
        if (rect.width && rect.height && rect.top < window.innerHeight && rect.bottom > 0) {
          top = Math.max(top, rect.bottom);
        }
      });
      satc.style.setProperty('--satc-top', top + 'px');
      var visible = buy.getBoundingClientRect().bottom < 0;
      satc.classList.toggle('show', visible);
      // Anchor links and focused controls clear the bar without changing page layout.
      root.style.scrollPaddingTop = visible ? (top + satc.offsetHeight + 12) + 'px' : originalScrollPadding;
    };
    sync();
    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    if ('ResizeObserver' in window) {
      var headerObserver = new ResizeObserver(sync);
      document.querySelectorAll(headerSelector).forEach(function (header) { headerObserver.observe(header); });
      headerObserver.observe(satc);
    }
  }
})();

/* Today's offer countdown — runs to the shopper's own midnight, then to the next one.
   Its own block so it still ticks if the gallery above bailed out, and hidden until the
   first tick so it can never flash a placeholder or a frozen "00:00:00". */
(function () {
  'use strict';
  var wrap = document.getElementById('offerEnds');
  var hh = document.getElementById('offerH');
  var mm = document.getElementById('offerM');
  var ss = document.getElementById('offerS');
  if (!wrap || !hh || !mm || !ss) return;

  var DAY = 86400;
  var pad = function (n) { return n < 10 ? '0' + n : String(n); };

  var tick = function () {
    var now = new Date();
    var midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    var left = Math.max(0, Math.min(DAY, Math.floor((midnight - now) / 1000)));
    var h = Math.floor(left / 3600), m = Math.floor(left / 60) % 60, s = left % 60;

    /* digits only — the unit labels are markup, so nothing here can disturb the layout */
    hh.textContent = pad(h);
    mm.textContent = pad(m);
    ss.textContent = pad(s);
    /* one label on the row, so a screen reader gets "2 hours 14 minutes left" rather than
       three bare numbers read out of context */
    wrap.setAttribute('aria-label', h + ' hours ' + m + ' minutes left in this offer');
    wrap.hidden = false;
  };

  tick();
  /* one second is the resolution shown; setInterval drifts, but the clock is re-derived
     from the wall clock on every tick, so it can't lag however long the tab sits open */
  setInterval(tick, 1000);
})();
